module.exports = __webpack_public_path__ + "static/media/bg_document.338afb46.jpg";